import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

export function useAirtableQuery<TData>(
    key: string,
    fetcher: () => Promise<TData>,
    options?: UseQueryOptions<TData>
): UseQueryResult<TData> {
    return useQuery<TData>(key, fetcher, {
        staleTime: 5 * 60 * 1000, // sensible defaults
        cacheTime: 10 * 60 * 1000,
        retry: 3,
        retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
        refetchOnWindowFocus: false,
        ...options, // allow overrides
    });
}
